// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Xq2I","row":"Node_row__WEi3q","label":"Node_label__3uNh6","footer":"Node_footer__1ovKb"};